import { Connector } from 'models/Connector';

/** API may serialize the deleted flag as `deleted` or `is_deleted`. */
export const isConnectorDeleted = (connector: Connector): boolean =>
  Boolean(connector.deleted ?? connector.is_deleted);
